(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const heroVideos = document.querySelectorAll('.main-slideshow video');

  if (!heroVideos.length) {
    return;
  }

  const activateDeferredSources = (video) => {
    let sourceChanged = false;
    video.querySelectorAll('source[data-autoplay-src]').forEach((source) => {
      source.src = source.dataset.autoplaySrc;
      source.removeAttribute('data-autoplay-src');
      sourceChanged = true;
    });
    if (sourceChanged) video.load();
  };

  const updateControl = (video) => {
    const slide = video.closest('.slideshow__slide');
    const control = slide?.querySelector('[data-hero-motion-toggle]');
    if (!control) return;

    const paused = video.paused;
    const icon = control.querySelector('.slideshow__motion-icon');
    const label = control.querySelector('[data-hero-motion-label]');
    icon?.classList.toggle('slideshow__motion-icon--pause', !paused);
    icon?.classList.toggle('slideshow__motion-icon--play', paused);
    if (label) {
      label.textContent = paused ? 'Play background video' : 'Pause background video';
    }
  };

  heroVideos.forEach((video) => {
    if (video.autoplay || video.dataset.deferredAutoplay === 'true') {
      video.dataset.homepageAutoplay = 'true';
    }

    const control = video.closest('.slideshow__slide')?.querySelector('[data-hero-motion-toggle]');
    control?.addEventListener('click', () => {
      if (video.paused) {
        activateDeferredSources(video);
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    video.addEventListener('play', () => updateControl(video));
    video.addEventListener('pause', () => updateControl(video));
  });

  const syncHeroMotion = () => {
    heroVideos.forEach((video) => {
      if (reducedMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        updateControl(video);
        return;
      }

      if (video.dataset.homepageAutoplay === 'true') {
        video.autoplay = true;
        activateDeferredSources(video);
        video.play().catch(() => updateControl(video));
      }
    });
  };

  syncHeroMotion();
  reducedMotion.addEventListener('change', syncHeroMotion);
})();
